import {call, put, select, take, fork} from "redux-saga/effects";
import {CODES} from "../../constants";
import {getUserInfo} from "../../reducers/app";
import API from "../../api/api";
import { linkFilters } from "../../reducers/searchLink";

export function *getLinkList(): Generator<any, void, any>{
	let userInfo = yield select(getUserInfo)
	let Filters = yield select(linkFilters)
	let params = {
		...Filters,
	    email: userInfo.email,
	    clientId: 'h5',
	}
	let resp = yield call(API.linkSearch, params)
	if (resp.code === CODES.SUCCESS && resp.data) {
		yield put({type: 'SET_LINK_LIST_INFO', payload: resp.data})
	}
}

function *getSearchLink(): Generator<any, void, any>{
	let userInfo = yield select(getUserInfo)
	let Filters = yield select(linkFilters)
	let params = {
		...Filters,
	    email: userInfo.email,
	    clientId: 'h5',
		currentPage: 1,
		recordsPerPage: 20,
	}
	let resp = yield call(API.linkSearch, params)
	if (resp.code === CODES.SUCCESS && resp.data) {
		yield put({type: 'SET_LINK_LIST_INFO', payload: resp.data})
		yield put({type: 'RESET_LINK_PAGE', payload: {currentPage: 1, recordsPerPage: 20}})
	}
}

export function *watchSearchLink(){
    while (true) {
        yield take('SEARCH_LINK')
		yield fork(getSearchLink)
    }
}

export function *watchClearFilters(){
    while (true) {
        yield take('RELOAD_LINK')
		yield fork(getLinkList)
    }
}

export function *watchLinkPageChange(){
    while (true) {
        yield take('SET_LINK_PAGE_INDEX')
		yield fork(getLinkList)
    }
}

export function *watchLinkSizeChange(){
	while (true) {
		yield take('SET_LINK_PAGE_SIZE')
		yield fork(getLinkList)
	}
}
